// import React from 'react';
// import { useInView } from 'react-intersection-observer';
// import emailjs from '@emailjs/browser';

// const Contact: React.FC = () => {
//   const { ref, inView } = useInView({ threshold: 0.12, triggerOnce: true });

//   return (
//     <section id="contact" className="section-dark">
//       <div className={`contact-inner max-w-[960px] mx-auto text-center reveal ${inView ? 'visible' : ''}`} ref={ref}>
//         <span className="section-tag">— Contact —</span>
//         <h2 className="section-title">Entrer en Contact</h2>
        
//         <p className="text-silver text-base leading-relaxed max-w-[500px] mx-auto mb-16">
//           Vous souhaitez en savoir plus sur GERAK, nos collections ou un partenariat ? Nous sommes à votre écoute.
//         </p>

//         <div className="grid grid-cols-1 md:grid-cols-3 gap-0.5 mb-14">
//           {[
//             { 
//               icon: (
//                 <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8 mx-auto text-gold">
//                   <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
//                 </svg>
//               ), 
//               label: 'Email', 
//               value: 'contact.gerak@gmail.com' 
//             },
//             { 
//               icon: (
//                 <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8 mx-auto text-gold">
//                   <path strokeLinecap="round" strokeLinejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
//                   <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
//                 </svg>
//               ), 
//               label: 'Localisation', 
//               value: 'Disponible partout' 
//             },
//             { 
//               icon: (
//                 <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8 mx-auto text-gold">
//                   <path strokeLinecap="round" strokeLinejoin="round" d="M7.217 10.907a2.25 2.25 0 100 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186l9.566-5.314m-9.566 7.5l9.566 5.314m0 0a2.25 2.25 0 103.935 2.186 2.25 2.25 0 00-3.935-2.186zm0-12.814a2.25 2.25 0 103.933-2.185 2.25 2.25 0 00-3.933 2.185z" />
//                 </svg>
//               ), 
//               label: 'Réseaux Sociaux', 
//               value: (
//                 <a 
//                   href="https://www.facebook.com/profile.php?id=100092598140989"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="hover:text-gold transition-colors"
//                 >
//                   @gerak.fashion
//                 </a>
//               )
//             },
//           ].map(contact => (
//             <div
//               key={contact.label}
//               className="bg-dark p-11 border border-mid text-center transition-all hover:border-silver hover:-translate-y-1 group"
//             >
//               <div className="mb-4">{contact.icon}</div>
//               <span className="text-[9px] tracking-[3px] uppercase text-gold mb-2.5 block">
//                 {contact.label}
//               </span>
//               <p className="text-silverLight text-sm">{contact.value}</p>
//             </div>
//           ))}
//         </div>

//         {/* Le reste du formulaire reste identique */}
//         <div className="bg-dark border border-mid p-12 lg:p-14 text-left max-w-[680px] mx-auto">
//           <h3 className="font-serif text-2xl text-white mb-8 tracking-[0.04em]">
//             Envoyez-nous un message
//           </h3>

//           <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
//             {['Prénom', 'Nom'].map(label => (
//               <div key={label} className="flex flex-col gap-2">
//                 <label className="text-[9px] tracking-[3px] uppercase text-gold">{label}</label>
//                 <input
//                   type="text"
//                   placeholder={`Votre ${label.toLowerCase()}`}
//                   className="bg-darkMid border border-mid text-white font-sans text-sm p-3.5 outline-none focus:border-silver placeholder:text-mid"
//                 />
//               </div>
//             ))}
//           </div>

//           {['Email', 'Sujet'].map(label => (
//             <div key={label} className="flex flex-col gap-2 mb-4">
//               <label className="text-[9px] tracking-[3px] uppercase text-gold">{label}</label>
//               <input
//                 type={label === 'Email' ? 'email' : 'text'}
//                 placeholder={label === 'Email' ? 'votre@email.com' : 'Objet de votre message'}
//                 className="bg-darkMid border border-mid text-white font-sans text-sm p-3.5 outline-none focus:border-silver placeholder:text-mid"
//               />
//             </div>
//           ))}

//           <div className="flex flex-col gap-2 mb-4">
//             <label className="text-[9px] tracking-[3px] uppercase text-gold">Message</label>
//             <textarea
//               placeholder="Votre message..."
//               rows={5}
//               className="bg-darkMid border border-mid text-white font-sans text-sm p-3.5 outline-none focus:border-silver placeholder:text-mid resize-none"
//             ></textarea>
//           </div>

//           <button className="w-full bg-white text-black border-none p-4 text-[10px] tracking-[3px] uppercase font-semibold mt-2 transition-all hover:bg-gold">
//             Envoyer le message →
//           </button>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Contact;



import React, { useState } from 'react';
import { useInView } from 'react-intersection-observer';
import emailjs from '@emailjs/browser';

const Contact: React.FC = () => {
  const { ref, inView } = useInView({ threshold: 0.12, triggerOnce: true });

  const [formData, setFormData] = useState({
    prenom: '',
    nom: '',
    email: '',
    sujet: '',
    message: '',
  });

  const [status, setStatus] = useState('');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('Transmission du message...');

    emailjs
      .send(
        'service_tbdlysk',   // Remplace par ton service ID EmailJS
        'template_iqau34f',  // Remplace par ton template ID EmailJS
        formData,
        'CcOreGTBD8iBgEY5L'    // Remplace par ta clé publique EmailJS
      )
      .then(() => {
        setStatus('Votre message a été envoyé avec succès. Notre équipe vous répondra rapidement.');
        setFormData({ prenom: '', nom: '', email: '', sujet: '', message: '' });
      })
      .catch(() => {
        setStatus("Une erreur est survenue lors de l'envoi. Veuillez réessayer.");
      });
  };

  return (
    <section id="contact" className="section-dark">
      <div
        className={`contact-inner max-w-[960px] mx-auto text-center reveal ${inView ? 'visible' : ''}`}
        ref={ref}
      >
        <span className="section-tag">— Contact —</span>
        <h2 className="section-title">Entrer en Contact</h2>

        <p className="text-silver text-base leading-relaxed max-w-[500px] mx-auto mb-16">
          Vous souhaitez en savoir plus sur GERAK, nos collections ou un partenariat ? Nous sommes à votre écoute.
        </p>

        {/* Cartes info */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-0.5 mb-14">
          {[
            {
              icon: (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-8 h-8 mx-auto text-gold"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"
                  />
                </svg>
              ),
              label: 'Email',
              value: 'contact.gerak@gmail.com',
            },
            {
              icon: (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-8 h-8 mx-auto text-gold"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z"
                  />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z"
                  />
                </svg>
              ),
              label: 'Localisation',
              value: 'Disponible partout',
            },
            {
              icon: (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-8 h-8 mx-auto text-gold"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M7.217 10.907a2.25 2.25 0 100 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186l9.566-5.314m-9.566 7.5l9.566 5.314m0 0a2.25 2.25 0 103.935 2.186 2.25 2.25 0 00-3.935-2.186zm0-12.814a2.25 2.25 0 103.933-2.185 2.25 2.25 0 00-3.933 2.185z"
                  />
                </svg>
              ),
              label: 'Réseaux Sociaux',
              value: (
                <a
                  href="https://www.facebook.com/profile.php?id=100092598140989"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-gold transition-colors"
                >
                  @gerak.fashion
                </a>
              ),
            },
          ].map((contact) => (
            <div
              key={contact.label}
              className="bg-dark p-11 border border-mid text-center transition-all hover:border-silver hover:-translate-y-1 group"
            >
              <div className="mb-4">{contact.icon}</div>
              <span className="text-[9px] tracking-[3px] uppercase text-gold mb-2.5 block">
                {contact.label}
              </span>
              <p className="text-silverLight text-sm">{contact.value}</p>
            </div>
          ))}
        </div>

        {/* Formulaire fonctionnel */}
        <div className="bg-dark border border-mid p-12 lg:p-14 text-left max-w-[680px] mx-auto">
          <h3 className="font-serif text-2xl text-white mb-8 tracking-[0.04em]">
            Envoyez-nous un message
          </h3>

          <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
              {['prenom', 'nom'].map((name) => (
                <div key={name} className="flex flex-col gap-2">
                  <label className="text-[9px] tracking-[3px] uppercase text-gold">{name}</label>
                  <input
                    type="text"
                    name={name}
                    placeholder={`Votre ${name}`}
                    value={formData[name as keyof typeof formData]}
                    onChange={handleChange}
                    className="bg-darkMid border border-mid text-white font-sans text-sm p-3.5 outline-none focus:border-silver placeholder:text-mid"
                    required
                  />
                </div>
              ))}
            </div>

            {['email', 'sujet'].map((name) => (
              <div key={name} className="flex flex-col gap-2 mb-4">
                <label className="text-[9px] tracking-[3px] uppercase text-gold">{name}</label>
                <input
                  type={name === 'email' ? 'email' : 'text'}
                  name={name}
                  placeholder={name === 'email' ? 'votre@email.com' : 'Objet de votre message'}
                  value={formData[name as keyof typeof formData]}
                  onChange={handleChange}
                  className="bg-darkMid border border-mid text-white font-sans text-sm p-3.5 outline-none focus:border-silver placeholder:text-mid"
                  required
                />
              </div>
            ))}

            <div className="flex flex-col gap-2 mb-4">
              <label className="text-[9px] tracking-[3px] uppercase text-gold">Message</label>
              <textarea
                name="message"
                placeholder="Votre message..."
                rows={5}
                value={formData.message}
                onChange={handleChange}
                className="bg-darkMid border border-mid text-white font-sans text-sm p-3.5 outline-none focus:border-silver placeholder:text-mid resize-none"
                required
              ></textarea>
            </div>

            <button
              type="submit"
              className="w-full bg-white text-black border-none p-4 text-[10px] tracking-[3px] uppercase font-semibold mt-2 transition-all hover:bg-gold"
            >
              Envoyer le message →
            </button>

            {/* {status && <p className="mt-2 text-sm text-white">{status}</p>} */}
            {status && (
  <div className="mt-6 border border-mid bg-darkMid p-4 flex items-center gap-3">
    
    {/* Icon */}
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="w-5 h-5 text-gold"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
    </svg>

    {/* Message */}
    <p className="text-silverLight text-sm tracking-wide">
      {status}
    </p>

  </div>
)}
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;